import React from 'react';
import styled from 'styled-components';

import FieldWrap from './FieldWrap';
import Typography from '../Typography';
import Caption from './Caption';
import { inputCss } from './styles';

type Props = {
    value?: string;
    disabled?: boolean;
    required?: boolean;
    error?: string;
    caption?: string;
    label?: string;
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

const TextareaStyled = styled.textarea`
    ${inputCss}
    min-height: 6em;
`;

const Textarea = React.forwardRef<HTMLTextAreaElement, Props & React.HTMLAttributes<HTMLTextAreaElement>>(
    ({ label, error, caption, disabled, onChange, ...rest }: Props, ref) => {
        return (
            <FieldWrap>
                {label && <Typography type="label">{label}</Typography>}
                <TextareaStyled
                    ref={ref}
                    invalid={!!error}
                    disabled={disabled}
                    onChange={e => !disabled && onChange && onChange(e)}
                    {...rest}
                />
                <Caption error={!!error}>{error || caption}</Caption>
            </FieldWrap>
        );
    },
);

export default Textarea;
